<template>
  <div>
    <!-- <v-simple-table dense>
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Sport</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(list, i ) in leagues"
          :key="i"
          class="clickable"
        >
          <td>
            <v-img
              v-if="list.logo"
              width="120"
              height="90"
              contain
              :src="list.logo.thumb_url"
            >
            </v-img>
            <v-img
              v-else
              width="120"
              height="90"
              contain
              :src="require('@/assets/images/no-image.png')"
            >
            </v-img>
          </td>
          <td>{{ list.name }}</td>
          <td>{{ list.type.toUpperCase() }}</td>
          <td class="text-center">
            <v-menu
              transition="slide-x-transition"
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="hoverable"
                  v-bind="attrs"
                  v-on="on"
                >mdi-dots-vertical</v-icon>
              </template>
              <v-list>
                <v-list-item class="clickable">
                  <v-list-item-title @click="triggerUnBoard(list, i)">
                    <v-icon>mdi-file-edit</v-icon>Remove
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
        <tr v-if="leagues.length === 0">
          <td colspan="3">No data available</td>
        </tr>
      </tbody>
    </v-simple-table> -->
    <div class="my-2">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="saveOrder"
          >Save order</v-btn>
        </template>
        <span>order items by dragging them</span>
      </v-tooltip>
    </div>
    <v-row>
      <v-col md="3"></v-col>
      <v-col md="3">League</v-col>
      <v-col md="3">Sport</v-col>
      <v-col md="3"></v-col>
    </v-row>
    <hr>
    <draggable
      v-model="leagues"
      group="people"
      @start="drag=true"
      @end="drag=false"
      class="list-group"
    >
      <v-row
        v-for="(list, i ) in leagues"
        :key="i"
        class="clickable list-group-item"
      >
        <v-col md="3">
          <v-img
            v-if="list.logo"
            width="120"
            height="30"
            contain
            :src="list.logo.thumb_url"
          >
          </v-img>
          <v-img
            v-else
            width="120"
            height="30"
            contain
            :src="require('@/assets/images/no-image.png')"
          >
          </v-img>
        </v-col>
        <v-col
          md="3"
          class="text-left"
        >{{ list.name }}</v-col>
        <v-col md="3">{{ list.type.toUpperCase() }}</v-col>
        <v-col
          md="3"
          class="text-center"
        >
          <v-menu
            transition="slide-x-transition"
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="hoverable"
                v-bind="attrs"
                v-on="on"
              >mdi-dots-vertical</v-icon>
            </template>
            <v-list>
              <v-list-item class="clickable">
                <v-list-item-title @click="triggerUnBoard(list, i)">
                  <v-icon>mdi-file-edit</v-icon>Remove
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </draggable>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-btn
      color="success"
      fab
      large
      dark
      bottom
      right
      fixed
      class="mb-4"
      @click="triggerAddLeague"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="showAddModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Add a league to onboarding options</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-autocomplete
              label="League"
              outlined
              :items="league_options"
              v-model="league_to_be_added"
            > </v-autocomplete>
            <span class="red--text text--lighten-2">*save any changes on sorting order before adding new item</span>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showAddModal = false"
          >Close</v-btn>
          <v-btn
            color="primary"
            class="text-color--white"
            @click="triggerOnBoard"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import filter from 'lodash/filter'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      leagues: [],
      available_leagues: [],
      loading: false,
      loading_message: 'Fetching League List',
      showAddModal: false,
      league_options: [],
      league_to_be_added: null

    }
  },
  props: {
    league_list: {
      type: Array,
      default () {
        return {}
      }
    }
  },

  components: {
    draggable
  },

  methods: {
    ...mapActions({
      unBoard: 'tag/unBoard',
      onBoard: 'tag/onBoard',
      updateOnboardingOrder: 'tag/updateOnboardingOrder'
    }),

    async triggerUnBoard (list, index) {
      this.loading = true
      this.loading_message = 'Removing from list. .'
      await this.unBoard(list.id)
        .then(() => {
          // let leagueIndex = this.league_list.findIndex(x => x.id === list.id)
          // this.league_list[leagueIndex].is_onboarding = false
          // this.updateLeagueData()
          this.$emit('refreshLeagueList')
        }).catch(err => {
          console.log(err)
        })
      this.loading = false
    },

    async triggerOnBoard () {
      if (!this.league_to_be_added) {
        this.showAddModal = false
        return false
      }
      this.showAddModal = false
      this.loading = true
      this.loading_message = 'Updating list. .'
      await this.onBoard(this.league_to_be_added)
        .then(() => {
          // let leagueIndex = this.league_list.findIndex(x => x.id === this.league_to_be_added)
          // this.league_list[leagueIndex].is_onboarding = true
          // this.updateLeagueData()
          this.$emit('refreshLeagueList')
        }).catch(err => {
          console.log(err)
        })
      this.league_to_be_added = null
      this.loading = false
    },

    updateLeagueData () {
      this.available_leagues = filter(this.league_list, { 'is_onboarding': false })
      this.leagues = filter(this.league_list, { 'is_onboarding': true })

      this.setLeagueOptions()
    },

    triggerAddLeague () {
      this.showAddModal = true
    },

    setLeagueOptions () {
      this.league_options = []
      this.available_leagues.forEach((value, key, map) => {
        this.league_options.push({
          'text': value.name,
          'value': value.id
        })
      })
    },

    async saveOrder () {
      let formData = new FormData()
      if (this.leagues) {
        this.leagues.map((item, i) => {
          formData.append(`onboarding_order[${i}][id]`, item.id)
          formData.append(`onboarding_order[${i}][index]`, i)
        })
        this.loading = true
        this.loading_message = 'Updating list. .'
        await this.updateOnboardingOrder(formData)
          .then(() => {
            this.$emit('refreshLeagueList')
          }).catch(err => {
            console.log(err)
          })
        this.loading = false
      }
    }
  },

  watch: {
    league_list: {
      immediate: true,
      handler (val) {
        if (val) {
          this.available_leagues = filter(val, { 'is_onboarding': false })
          this.leagues = filter(val, { 'is_onboarding': true })
        }
      }
    },
    available_leagues (val) {
      if (val.length > 0) {
        this.setLeagueOptions()
      }
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  background-color: #eeeeee;
}
</style>
